// src/views/login/TerminosCondicionesPassword.jsx
import React, { useMemo, useState } from "react";

export default function TerminosCondicionesPassword({
  nombreUsuario = "",
  onVolver = () => {},
  onGuardado = async () => {},
  terminosUrl = "/terminos-condiciones-flota.pdf",
}) {
  const [clave, setClave] = useState("");
  const [clave2, setClave2] = useState("");
  const [acepta, setAcepta] = useState(false);

  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const saludo = useMemo(() => {
    if (!nombreUsuario) return "Bienvenido/a";
    return `Estimado/a ${nombreUsuario}:`;
  }, [nombreUsuario]);

  // ========== VALIDACIÓN EN VIVO ==========
  const validarEnVivo = (c1, c2, aceptaFlag) => {
    const e = {};

    // Reglas obligatorias
    if (!c1) e.clave = "La clave es obligatoria.";

    // Longitud
    if (c1 && c1.length < 8) {
      e.clave = "La clave debe tener al menos 8 caracteres.";
    }

    // Alfanumérico
    const alfanumerica = /^(?=.*[A-Za-z])(?=.*\d).+$/;
    if (c1 && !alfanumerica.test(c1)) {
      e.clave = "La clave debe contener letras y números.";
    }

    // Confirmación
    if (!c2) e.clave2 = "La confirmación es obligatoria.";

    // Coincidencia
    if (c1 && c2 && c1 !== c2) {
      e.clave2 = "Las claves ingresadas no coinciden.";
    }

    // Términos
    if (!aceptaFlag) {
      e.acepta = "Debés aceptar los Términos y Condiciones.";
    }

    setErrors(e);
  };

  // === manejar cambios con validación en vivo ===
  const handleClaveChange = (val) => {
    setClave(val);
    validarEnVivo(val.trim(), clave2.trim(), acepta);
  };

  const handleClave2Change = (val) => {
    setClave2(val);
    validarEnVivo(clave.trim(), val.trim(), acepta);
  };

  const handleAcepta = (checked) => {
    setAcepta(checked);
    validarEnVivo(clave.trim(), clave2.trim(), checked);
  };

  // ========== VALIDACIÓN FINAL (usar errors generados) ==========
  const puedeGuardar = useMemo(() => {
    return (
      clave.trim().length >= 8 &&
      /^(?=.*[A-Za-z])(?=.*\d).+$/.test(clave.trim()) &&
      clave.trim() === clave2.trim() &&
      acepta
    );
  }, [clave, clave2, acepta]);

  const openOverlay = (detail) => {
    if (window.overlay?.open) window.overlay.open(detail || {});
    else window.dispatchEvent(new CustomEvent("overlay:open", { detail }));
  };

  const handleGuardar = async () => {
    if (saving) return;
    if (!puedeGuardar) return;

    setSaving(true);

    openOverlay({
      mode: "loading",
      title: "Actualizando contraseña…",
      message: "Por favor, espere sin cerrar ni recargar la página.",
    });

    try {
      await onGuardado({ password: clave.trim() });
      openOverlay({
        mode: "success",
        title: "Operación realizada",
        message: "Tu contraseña fue actualizada correctamente.",
        onClose: onVolver,
      });
    } catch (e) {
      openOverlay({
        mode: "error",
        title: "Error",
        message: e?.message || "No se pudo actualizar la contraseña.",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page max-w-4xl px-4">

      <div className="mb-3">
        <img src="/imgs/header.jpg" alt="" className="w-full object-contain" />
      </div>

      <p className="text-sm text-gray-700 mb-4">
        Por Favor, debe aceptar los Términos y Condiciones. Definir una nueva clave de acceso de al menos 8 caracteres alfanumérico.
      </p>

      <div className="rounded-md border border-gray-200 bg-white px-6 py-5 space-y-4">

        {/* SALUDO */}
        <div>
          <div className="font-semibold text-emerald-800 text-sm mb-1">{saludo}</div>
          <a href={terminosUrl} target="_blank" rel="noopener noreferrer" className="text-emerald-700 text-sm underline hover:text-emerald-900">
            Haga click aquí para ver los Términos y Condiciones
          </a>
        </div>

        <hr />

        <div className="text-sm font-semibold text-gray-800 mb-2">
          Actualizá la clave de tu Usuario
        </div>

        {/* CLAVE */}
        <div className="form-row gap-2 items-center mb-2">
          <div className="form-label">Clave<span className="text-red-600">*</span>:</div>
          <div className="flex-1">
            <input
              type="password"
              className="input w-full rounded-full"
              value={clave}
              onChange={(e) => handleClaveChange(e.target.value)}
              disabled={saving}
            />
            {errors.clave && (
              <div className="mt-1 text-xs text-red-600">{errors.clave}</div>
            )}
          </div>
        </div>

        {/* CONFIRMAR CLAVE */}
        <div className="form-row gap-2 items-center mb-2">
          <div className="form-label">Confirmar Clave<span className="text-red-600">*</span>:</div>
          <div className="flex-1">
            <input
              type="password"
              className="input w-full rounded-full"
              value={clave2}
              onChange={(e) => handleClave2Change(e.target.value)}
              disabled={saving}
            />
            {errors.clave2 && (
              <div className="mt-1 text-xs text-red-600">{errors.clave2}</div>
            )}
          </div>
        </div>

        {/* ACEPTA TyC */}
        <div className="mt-3 flex items-center gap-2">
          <input
            id="chkTerminos"
            type="checkbox"
            checked={acepta}
            disabled={saving}
            onChange={(e) => handleAcepta(e.target.checked)}
          />
          <label htmlFor="chkTerminos" className="text-sm text-gray-800">
            He leído, acepto los Términos y Condiciones
          </label>
        </div>

        {errors.acepta && (
          <div className="mt-1 text-xs text-red-600">{errors.acepta}</div>
        )}

        {/* BOTÓN GUARDAR */}
        <div className="mt-5 flex justify-end">
          <button
            type="button"
            className="btn-fil min-w-[140px] disabled:opacity-60 disabled:cursor-not-allowed"
            onClick={handleGuardar}
            disabled={!puedeGuardar || saving}
          >
            {saving ? "Guardando…" : "Guardar"}
          </button>
        </div>

      </div>
    </div>
  );
}
